import { z } from 'zod';
export const userApiRoutes = {
    login: {
        method: 'POST',
        path: '/login',
        input: z.object({
            email: z.string().email(),
            password: z.string(),
            inviteKey: z.string().optional(),
        }),
        output: {},
    },
    logout: {
        method: 'POST',
        path: '/logout',
        output: {},
    },
    me: {
        method: 'GET',
        path: '/user/whoami',
        output: {},
    },
    register: {
        method: 'POST',
        path: '/user/register',
        input: z
            .object({
            firstName: z.string(),
            lastName: z.string(),
            email: z.string().email(),
            password: z.string(),
            timezone: z.string(),
            $$autoVerify: z.boolean().optional(),
            inviteKey: z.string().optional(),
        })
            .strict(),
        output: {},
    },
    verifyUser: {
        method: 'POST',
        path: '/user/verify',
        input: z.object({ verificationCode: z.string() }),
        output: {},
    },
    resendVerificationEmail: {
        method: 'POST',
        path: '/user/resend-verification-email',
        input: z.object({ email: z.string().email() }),
        output: {},
    },
    forgotPassword: {
        method: 'POST',
        path: '/user/forgot-password',
        input: z.object({ email: z.string().email() }),
        output: {},
    },
    resetPassword: {
        method: 'POST',
        path: '/user/reset-password',
        input: z.object({ token: z.string(), password: z.string() }),
        output: {},
    },
    checkPasswordResetToken: {
        method: 'POST',
        path: '/user/check-password-reset-token',
        input: z.object({ token: z.string() }),
        output: {},
    },
    changePassword: {
        method: 'POST',
        path: '/user/change-password',
        input: z.object({
            currentPassword: z.string(),
            newPassword: z.string(),
        }),
        output: {},
    },
    update: {
        method: 'PATCH',
        path: '/user',
        input: z.object({
            firstName: z.string().min(1).optional(),
            lastName: z.string().min(1).optional(),
            guides: z.record(z.array(z.string())).optional(),
            timezone: z.string().optional(),
        }),
        output: {},
    },
};
//# sourceMappingURL=user-api-routes.js.map